module.exports = __webpack_public_path__ + "static/media/manu-8.332b4fb9.png";